import { Trans, useTranslation } from 'react-i18next';
import Styles from './Styles.module.scss';
import { Footer } from 'app/Footer';

export const Privacy: React.FC = () => {
  const { t } = useTranslation();
  return (
    <div>
      <div className={Styles.container}>
        <p className={Styles.title}>{t('DataProtectionTitle')}</p>

        <p className={Styles.text}>{t('DataProtection_Intro')}</p>

        <p className={Styles.header}>{t('DataProtection_Contact_Header')}</p>
        <p className={Styles.text}>{t('DataProtection_Contact_Text')}</p>

        <p className={Styles.header}>{t('DataProtection_Cookie_Header')}</p>
        <p className={Styles.text}>{t('DataProtection_Cookie_Text')}</p>

        <p className={Styles.header}>{t('DataProtection_InformationUsage_Header')}</p>
        <p className={Styles.text}>{t('DataProtection_InformationUsage_Text')}</p>

        <p className={Styles.header}>{t('DataProtection_Provisions_Header')}</p>
        <p className={Styles.text}>{t('DataProtection_Provisions_Text')}</p>

        <p className={Styles.header}>{t('DataProtection_Questions_Header')}</p>
        <p className={Styles.text}>{t('DataProtection_Questions_Text')}</p>

        <hr />

        <p className={Styles.header}>{t('DataProtection_Contacts_Header')}</p>
        <p className={Styles.text}>
          <Trans i18nKey="DataProtection_Contacts_Text">
            <a
              target="_blank"
              rel="noopener noreferrer"
              href={`tel:${t('DataProtection_Contacts_Telephone')}`}
            >
              phone
            </a>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href={`${t('DataProtection_Contacts_WebSite')}`}
            >
              site
            </a>
          </Trans>
        </p>
      </div>

      <div className="splitter appContainerBottomSplitter" />
      <Footer />
    </div>
  );
};
